import type { FC } from 'react'
import { TiptapSuggestionsWidget } from './tiptap-suggestions-widget'

type TiptapSuggestionsLoadingProps = {
  text: string
}

export const TiptapSuggestionsLoading: FC<TiptapSuggestionsLoadingProps> = ({
  text = 'Loading...',
}) => {
  return (
    <TiptapSuggestionsWidget>
      <div className="flex items-center gap-2 px-3 py-2">
        <span className="relative inline-flex rounded-full h-4 w-4 border-2 border-gray-300 border-t-transparent animate-spin motion-reduce:animate-none" />
        <span className="text-sm text-gray-200">{text}</span>
        <span className="sr-only" role="status" aria-live="polite">
          Loading
        </span>
      </div>
    </TiptapSuggestionsWidget>
  )
}
